var plugin_rtlignore_default = {
  "alignLeft": "Jkc2b",
  "textWrapNowrap": "pu3yO",
  "alignRight": "ROFm5",
  "alignCenter": "S13wp",
  "sizeFullWidth": "_3nmYO",
  "renderedInTable": "r1yTL",
  "sizeOriginal": "_34iJP",
  "sizeContent": "JJIO5",
  "sizeSmall": "gzq7F",
  "sizeSmallCenter": "OSX-e",
  "flex": "KtgLU",
  "atomic": "NECaN",
  "embed": "MO-z7",
  "horizontalScrollbar": "LNBR7",
  "pluginContainerMobile": "GqIXQ"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
